import { Link } from 'react-router-dom';
import '../styles/home.scss';

import Slide1 from '../assets/slider/home1-slider1.webp';

export default function HeroSection() {
  const slide = {
    image: Slide1,
    heading: 'Build With Confidence',
    text: 'Discover authentic craftsmanship from Kenya’s finest makers — from custom-made pieces to ready-made products.',
    align: 'left',
    customButton: {
      text: 'Request Custom Work',
      link: '/client-dashboard',
      icon: '🎨'
    },
    readyButton: {
      text: 'Browse Ready-Made',
      link: '/ready-made-products',
      icon: '🛍️'
    }
  };

  return (
    <section className="hero-section">
      <div
        className="hero-slide active"
        style={{ backgroundImage: `url(${slide.image})` }}
      >
        <div className="overlay"></div>

        <div
          className={`content-container container ${
            slide.align === 'left' ? 'align-left' : 'align-right'
          }`}
        >
          <p className="subtitle">Welcome to Artiza</p>
          <h1>{slide.heading}</h1>
          <p className="description">{slide.text}</p>

          <div className="button-group">
            <Link
              to={slide.customButton.link}
              className="btn btn-outline-light px-4 py-2 fw-semibold hero-btn custom-btn"
            >
              <span className="btn-icon">{slide.customButton.icon}</span>
              {slide.customButton.text}
            </Link>

            <Link
              to={slide.readyButton.link}
              className="btn btn-light px-4 py-2 fw-semibold hero-btn ready-btn"
            >
              <span className="btn-icon">{slide.readyButton.icon}</span>
              {slide.readyButton.text}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
